/**
 * Payroll module theme — aliases app brand (Patient indigo SoT).
 *
 * Prefer importing from here in Payroll UI so the module stays swappable
 * without reaching into Patients/. Color changes still flow from patientTheme.
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../ui/brandTheme";

export const PAYROLL_THEME = BRAND_THEME;
export const PAYROLL_THEME_HEX = BRAND_THEME_HEX;

/** Shared role chip — one brand tone (not per-role rainbow). */
export const PAYROLL_ROLE_CHIP =
  "bg-indigo-50 text-indigo-700 border border-indigo-100";

/**
 * Compact row actions — same density as Patient / Documents (h-6 / 11px).
 */
export const PAYROLL_BTN = {
  soft: `inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  outline: `inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.outline}`,
  link: `inline-flex items-center gap-1 text-[11px] font-medium ${BRAND_THEME.button.link}`,
  clear:
    "inline-flex items-center gap-1 h-8 px-2.5 text-xs font-medium text-indigo-700 hover:bg-indigo-50 rounded-md border border-indigo-200 transition-colors whitespace-nowrap",
  modalClose:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

/** Form field chrome (Patient density). */
export const PAYROLL_FIELD = {
  search: `w-full h-8 pl-9 pr-8 text-sm bg-white border border-indigo-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  select: `appearance-none h-8 min-w-[140px] pl-3 pr-8 text-sm rounded-md border border-indigo-200 text-slate-700 bg-white outline-none cursor-pointer transition-colors ${BRAND_THEME.fieldFocus}`,
  selectActive:
    "border-indigo-400 text-indigo-700 font-medium bg-indigo-50/60",
};

/**
 * Column widths for `table-fixed` — include Sr. No. (~5%) so leftover
 * space does not inflate the first column.
 */
export const PAYROLL_COL = {
  srNo: "w-[5%] min-w-[2.75rem] text-center align-middle",
  employee: "w-[16%] min-w-0 pl-3 pr-3 align-middle",
  email: "w-[22%] min-w-0 px-3 align-middle",
  attendance: "w-[14%] whitespace-nowrap px-3 align-middle",
  workMode: "w-[8%] whitespace-nowrap px-3 align-middle",
  role: "w-[8%] whitespace-nowrap px-3 align-middle",
  status: "w-[8%] whitespace-nowrap px-3 align-middle",
  actions: "w-[14%] whitespace-nowrap pl-2 pr-3 text-right align-middle",
};
